import { axiosClientv1 } from "./apiClient";
import { ApiResponse, CoilWidth } from "../Types";

export const GetCoilWidths = async (): Promise<ApiResponse<CoilWidth[]>> => {
  try {
    const response = await axiosClientv1.get(`/coil-widths/active`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load coil widths.",
      data: [],
      error: { code: error?.response?.status || 500, type: "server_error" },
    };
  }
};

export const CreateCoilWidth = async (formData: {
  name: string;
  width_ft?: number;
  width_mm?: number;
}): Promise<ApiResponse<CoilWidth>> => {
  try {
    const response = await axiosClientv1.post(`/coil-widths/create`, formData);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to create coil width.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};

export const UpdateCoilWidth = async (formData: {
  id: string;
  name: string;
  width_ft?: number;
  width_mm?: number;
}): Promise<ApiResponse<CoilWidth>> => {
  try {
    const response = await axiosClientv1.post(`/coil-widths/update`, formData);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to update coil width.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};

export const DeleteCoilWidth = async (
  id: string,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/coil-widths/delete`, { id });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete coil width.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};
